import store from '@/store/store';
/**
 * Route must be authenticate, if user is authenticated, push them to home
 */
export default function noAuth({ next, router }) {
  const token = store.getters.getLoggedInUserToken;
  const businessId = store.getters.getLoggedInUserSelectedBusinessId;
  if (token && businessId) {
    return router.push({ name: 'Applications' });
  }
  return next();
}
